import { render, staticRenderFns } from "./BaseFlow.vue?vue&type=template&id=115d976a&lang=pug&"
import script from "./BaseFlow.vue?vue&type=script&lang=ts&"
export * from "./BaseFlow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports